import '../../../style/header-filter.scss'
import { createFilterContent } from './filter-content'
import { isFunction } from 'lodash'

const FiltersContent = createFilterContent()

const filterClass = 'kye-table-v2-header-filter-icon'
export function createHeaderFilter() {
  return {
    functional: true,
    render(h, context) {
      const column = context.props.column || {}
      const {
        filterIcon = 'layout layout-filter',
        filters,
        key,
        filterMultiple
      } = column
      const { values } = context.props.store.states.filtersMap[key] || {}
      const active = Array.isArray(filters) && filterMultiple !== false ? !!(values || []).length : !!values
      const click = (event) => {
        event.stopPropagation()
        const {
          filterVisibleArrow = false,
          filterTrigger = 'click',
          filterPlacement = 'bottom-end',
          filterTitle = '',
          filterOffset = 0,
          filterTabindex = 0,
          filterPopperOptions = {},
          filterPopperClass,
          filters,
          filterContentRender,
          filterShowCallback,
          filterHideCallback,
        } = column
        const popperClass = ['kye-table-v2-header-filter', filterPopperClass].filter(Boolean).join(' ')
        const headerPopoverAttrs = {
          props: {
            popperClass: popperClass,
            placement: filterPlacement,
            visibleArrow: filterVisibleArrow,
            title: filterTitle,
            offset: filterOffset,
            popperOptions: filterPopperOptions,
            tabindex: filterTabindex,
            trigger: filterTrigger,
            reference: event.target,
          },
          on: {
            show: () => {
              if (isFunction(filterShowCallback)) {
                filterShowCallback(values, {column})
              }
            },
            hide: () => {
              if (isFunction(filterHideCallback)) {
                filterHideCallback(values, {column})
              }
            }
          }
        }
        const changeHeaderPopoverVisibleStatus = () => {
          context.parent.$nextTick(() => {
            context.props.changeHeaderPopoverVisibleStatus()
          })
        }
        const createPopperElm = () => {
          return filterContentRender ? (
            filterContentRender(h, {
              column,
              onFilter: (...args) => {
                context.props.store.onFilter(...args, column)
                changeHeaderPopoverVisibleStatus()
              },
              resetFilter: context.props.store.resetFilter
            })
          ) : (
            <FiltersContent
              column={column}
              filters={filters}
              store={context.props.store}
              changeHeaderPopoverVisibleStatus={context.props.changeHeaderPopoverVisibleStatus}
            ></FiltersContent>
          )
        }
        const { props = {} } = context.props.getHeaderPopoverAttrs ? context.props.getHeaderPopoverAttrs() : {}
        const { reference } = props
        if (reference && (reference !== headerPopoverAttrs.props.reference)) {
          context.props.changeHeaderPopoverVisibleStatus(false)
        }
        context.props.setHeaderPopoverAttrs(headerPopoverAttrs, createPopperElm)
        changeHeaderPopoverVisibleStatus()
      }
      const FiltersVnode = (filters || column.filterContentRender) ? (
        <i
          class={[filterClass, active ? 'active' : '', filterIcon]}
          on-click={click}
        ></i>
      ) : null
      return FiltersVnode
    },
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/feature/filter/index.js